import React from "react";
import { useNavigate } from "react-router-dom";

//Assets
import IconAmbiental from "../img/icons/IconoAmbiental.png";
import IconZonasVerder from "../img/icons/IconoZonasverdes.png";
import IconPuntosInteres from "../img/icons/IconoPuntosdeinteres.png";
import IconProyectosExistentes from "../img/icons/IconoViviendasExistentes.png";
import IconProyectosContruccion from "../img/icons/IconoViviendasConstruccion.png";
import IconProyectosFuturo from "../img/icons/IconoViviendasFuturo.png";

//Inputs
import HomeMenuButton from "../inputs/HomeMenuButton";

export default function HomeMenu() {
    const navigate = useNavigate();

    return(
        <nav style={{width:"100%", maxWidth:"100%", height:"80px", position:"absolute", bottom:"0px",
        display:"inline-flex", backgroundColor:"var(--home-menu-background)", boxSizing:"border-box",
        justifyContent:"space-between", alignItems:"center", paddingLeft:"20px", paddingRight:"20px"}}>
            <HomeMenuButton icon={IconAmbiental} title="AMBIENTAL" onClick={()=>navigate('ambiental')}/>
            <HomeMenuButton icon={IconZonasVerder} title="ZONAS VERDES" onClick={()=>navigate('zonas_verdes')}/>
            <HomeMenuButton icon={IconPuntosInteres} title="PUNTOS DE INTERES" onClick={()=>navigate('puntos_interes')}/>
            <HomeMenuButton icon={IconProyectosExistentes} title="PROYECTOS EXISTENTES" onClick={()=>navigate('viviendas_existentes')}/>
            <HomeMenuButton icon={IconProyectosContruccion} title="PROYECTOS EN DESARROLLO" onClick={()=>navigate('viviendas_construccion')}/>
            <HomeMenuButton icon={IconProyectosFuturo} title="PROYECTOS A FUTURO" onClick={()=>navigate('viviendas_futuras')}/>
        </nav>
    );
}